import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Fetch awards data
export const allAwardsData = createAsyncThunk(
  "award/allAwardsData",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/awards/list-awards`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const awardSlice = createSlice({
  name: "award",
  initialState: {
    awardsData:null
  },
  extraReducers: (builder) => {
    builder
       // awardsData data
       .addCase(allAwardsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(allAwardsData.fulfilled, (state, action) => {
        state.loading = false;
        state.awardsData = action.payload;
      })
      .addCase(allAwardsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default awardSlice.reducer;
